export default __webpack_public_path__ + "static/DMSans-Regular-6ff3dc468ef386ea4d007e1e4b3406c5.woff2";